export function displayEvaluationAccuracy(accuracy?: number) {
  if (accuracy == null) return 'N/A';

  return `${accuracy}%`;
}
